export const CURRENT_ADDRESS_COOKIE = "currentAddress";
export const LAST_SELECTED_NETWORK = "lastSelectedNetwork";
export const LAST_THEME = "lastTheme";
export const UTM_CACHE = "__UTM_CACHE_INTERNAL_";
export const CHART_SETTINGS = "chartSettings";
